import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'PDRDebito'

const GetSummaryByEmployee = (companyId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/resumo/${companyId}`, data, config)
const GetDebits = (employeeId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${employeeId}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)
const Delete = (id, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${id}`, data, config)
const Download = (data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/download`, data, config)

const PDRDebitsRepository = {
  GetSummaryByEmployee,
  GetDebits,
  Create,
  Update,
  Delete,
  Download
}

export default PDRDebitsRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/pdrdebits.js